"use strict";

var _ethers = require("ethers");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.formatBN = exports.tenPow = void 0;

function sameFraction(first, second) {
  // Check that these two values are the same.
  // Note that leading zeros ARE meaningful, and so we do the comparision after
  // appending a one as the first digit.
  //
  // For example, .001 and .00100 are the same value, but .0001 and .001 are not.
  return first = first.replace(/0+$/, ""), second = second.replace(/0+$/, ""), _ethers.BigNumber.from("1".concat(first)).eq(_ethers.BigNumber.from("1".concat(second)));
}

var tenPow = function tenPow(x) {
  return _ethers.BigNumber.from(10).pow(_ethers.BigNumber.from(x));
};

exports.tenPow = tenPow;

var formatBN = function formatBN(amount, base, precision) {
  var fixed = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
  // Inspired by: https://github.com/ethjs/ethjs-unit/blob/35d870eae1c32c652da88837a71e252a63a83ebb/src/index.js#L83
  var baseLength = base.toString().length,
      whole = amount.div(base).toString();
  var fraction = amount.mod(base).toString();
  var zeros = "0".repeat(Math.max(0, baseLength - fraction.length - 1));
  fraction = "".concat(zeros).concat(fraction);
  var fractionWithoutTrailingZeros = fraction.replace(/0+$/, ""),
      fractionAfterPrecision = (fixed ? fraction : fractionWithoutTrailingZeros).slice(0, precision);
  if (!fixed && ("" === fractionAfterPrecision || 0 === parseInt(fractionAfterPrecision, 10))) return whole;
  var prefix = sameFraction(fractionAfterPrecision, fraction) ? "" : "~";
  return "".concat(prefix).concat(whole, ".").concat(fractionAfterPrecision);
};

exports.formatBN = formatBN;